import React from "react";

import "assets/css/safexpay-web.css";
import "./Clients.css";

class Clients extends React.Component {
  render() {
    return (
      <>
        <section className="dv-Clients mt-0 pb-5 mb-5">
          <div className="container">
            <h2
              className="section-heading"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Thousands OF Business Trust Us
            </h2>
            <div className="justify-content-center">
              <div
                className="dv-logo"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght bd-bot"
                  src={require("assets/img/home/shell.png")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght bd-bot"
                  src={require("assets/img/home/telr.png")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght bd-bot no-bd-rght67"
                  src={require("assets/img/home/commonfolks.png")}
                /> */}
                <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot bd-rght yes-bd-rght67"
                  src={require("assets/img/home/zipgrid.png")}
                />
                <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot bd-rght"
                  src={require("assets/img/home/pcj.png")}
                />
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot yes-bd-rght91 no-bd-rght67"
                  src={require("assets/img/home/melorra.png")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght yes-bd-bot91"
                  src={require("assets/img/home/commonfolks.png")}
                /> */}
                {/* <div className="blank-box"></div> */}
                <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot bd-rght no-bd-rght67"
                  src={require("assets/img/home/railwaynew.png")}
                  style={{ padding: "15px" }}
                />
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-lft bd-rght  bd-bot yes-bd-bot91 margin-0 yes-bd-rght67"
                  src={require("assets/img/home/cashfree.png")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght mswip margin-0 bd-bot  no-bd-rght91 yes-bd-bot91 yes-bd-bot67"
                  style={{ marginLeft: "1px" }}
                  src={require("assets/img/home/mswip.png")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-lft-91 bd-rght bd-bot  no-bd-rght67 margin-0 yes-bd-bot67 imoney"
                  src={require("assets/img/home/imoney.jpg")}
                /> */}
                {/* <img
                  alt="safexpay-img"
                  className="img-fluid bd-rght margin-0  bd-bot  quickw"
                  src={require("assets/img/home/quickw.png")}
                /> */}
                
                <img
                alt="safexpay-img"
                className="img-fluid bd-bot bd-lft yes-bd-rght67"
                src={require("assets/img/home/govofraj.jpg")}
                style={{ padding: "15px" }}
              />


                <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot bd-lft no-bd-lft91 yes-bd-rght67"
                  src={require("assets/img/home/csvtunew.jpg")}
                />
                <img
                  alt="safexpay-img"
                  className="img-fluid bd-bot bd-lft yes-bd-rght91 no-bd-rght67"
                  src={require("assets/img/home/mahadiscom.png")}
                />
                <img
                    alt="safexpay-img"
                    className="img-fluid yes-bd-bot91  yes-bd-rght91 mpcon mpcon767 "
                    src={require("assets/img/home/mpcon.png")}
                    
                  />
               <img
                alt="safexpay-img"
                className="img-fluid bd-lft yes-bd-bot91 yes-bd-rght67"
                src={require("assets/img/home/msme.png")}
                style={{ padding: "10px 5px", minHeight:"150px" }}
              />
              <img
                alt="safexpay-img"
                className="img-fluid bd-lft  no-bd-lft91 yes-bd-bot67"
                src={require("assets/img/home/south_delhi_mun_corp.png")}
                style={{ padding: "15px" }}
              />
              <img
                alt="safexpay-img"
                className="img-fluid bd-lft yes-bd-rght67"
                src={require("assets/img/home/mtnl_logo.png")}
              />
              <img
                alt="safexpay-img"
                className="img-fluid bd-lft yes-bd-rght67"
                src={require("assets/img/home/modern_school_logo.jpg")}
                style={{ padding: "15px" }}
              />
              <img
                alt="safexpay-img"
                className="img-fluid bd-lft"
                src={require("assets/img/home/bosco_logo.png")}
                style={{ padding: "15px" }}
              />

                {/* <img alt="safexpay-img" className="img-fluid" src={""} /> */}
                {/* <div className="blank-box"></div> */}
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Clients;
